import { createRouter, createWebHistory } from "vue-router";

import Main from "~/layout/App/Index.vue";
import PageNotFound from "~/views/404.vue";
import authRoutes from "~/router/modules/authRoutes";
import profileRoutes from "~/router/modules/profileRoutes";
import historyRoutes from "~/router/modules/historyRoutes";
import counterpartyRoutes from "~/router/modules/counterpartyRoutes";
import contractRoutes from "~/router/modules/contractRoutes";
import invitationRoutes from "~/router/modules/invitationRoutes";
import contractCabinetRoute from "~/router/modules/contractCabinetRoute";
// import certificatesRoutes from "~/router/modules/certificatesRoutes";
import databasesRoutes from "~/router/modules/databasesRoutes";
import balanceRoutes from "~/router/modules/balanceRoutes";
import referralRoutes from "~/router/modules/referralRoutes";
import orderRoutes from "~/router/modules/orderRoutes";
import cacheRoutes from "~/router/modules/cacheRoutes";
// import processorsRoutes from "~/router/modules/processorsRoutes";
import logsRoutes from "~/router/modules/logsRoutes";
import cronsRoutes from "~/router/modules/cronsRoutes";
import priceRoutes from "~/router/modules/priceRoutes";
import instructionRoutes from "~/router/modules/instructionRoutes";
import supportRoutes from "~/router/modules/supportRoutes";
import mcpAccessRoutes from "~/router/modules/mcpAccessRoutes";
import store from "~/store";
import BaseUI from "~/views/BaseUI.vue";
import NavigationProgress from "~/utils/navigationProgress";

// import auth from "./middleware/auth";

const routes = [
  authRoutes,
  profileRoutes,
  historyRoutes,
  counterpartyRoutes,
  contractRoutes,
  invitationRoutes,
  balanceRoutes,
  referralRoutes,
  orderRoutes,
  // certificatesRoutes,
  databasesRoutes,
  contractCabinetRoute,
  cacheRoutes,
  // processorsRoutes,
  logsRoutes,
  cronsRoutes,
  priceRoutes,
  instructionRoutes,
  supportRoutes,
  mcpAccessRoutes,
  {
    path: "/404",
    name: "error.404",
    component: PageNotFound
  },
  {
    path: "/",
    name: "Home",
    component: Main,
    meta: {
      breadcrumb: [{ name: "breadcrumb.database.main", route: "home.index" }],
    },
    children: [
      { path: "404", component: PageNotFound, name: "PageNotFound" },
      {
        path: "",
        component: () => import("~/views/MainDashboard/Index"),
        name: "home.index",
        meta: {
        }
      },
    ]
  },
  {
    path: "/base-ui",
    name: "BaseUI",
    component: BaseUI
  },
  { path: "/:pathMatch(.*)*", component: PageNotFound }
];

const router = createRouter({
  scrollBehavior(to, from, savedPosition) {
    return {
      el: "#cabinet",
      top: 10
    };
  },
  history: createWebHistory(),
  routes
});

// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
// function nextFactory(context, middleware, index) {
//   const subsequentMiddleware = middleware[index];
//   // If no subsequent Middleware exists,
//   // the default `next()` callback is returned.
//   if (!subsequentMiddleware) return context.next;

//   return (...parameters) => {
//     // Run the default Vue Router `next()` callback first.
//     context.next(...parameters);
//     // Then run the subsequent Middleware with a new
//     // `nextMiddleware()` callback.
//     const nextMiddleware = nextFactory(context, middleware, index + 1);
//     subsequentMiddleware({ ...context, next: nextMiddleware });
//   };
// }

const navigationProgress = new NavigationProgress();
const originalPush = router.push;
const originalReplace = router.replace;

router.push = function (to) {
  navigationProgress.reset();
  navigationProgress.start();
  document.body.classList.add('navigation-loading');

  return originalPush.call(this, to).finally(() => {
    document.body.classList.remove('navigation-loading');
  });
};

router.replace = function (to) {
  navigationProgress.reset();
  navigationProgress.start();
  document.body.classList.add('navigation-loading');

  return originalReplace.call(this, to).finally(() => {
    document.body.classList.remove('navigation-loading');
  });
};

router.beforeEach((to, from, next) => {
  if (to.meta.middleware && to.name !== from.name) {
    const middlewares = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware];

    const context = {
      from,
      next,
      router,
      to
    };

    for (let i = 0; i < middlewares.length; i++) {
      const path = middlewares[i](context);
      if (path !== null) {
        return next(path);
      }
    }
  }

  if (!to.params.contractName) {
    to.params.contractName = store.getters["contract/activeContract"]?.name;
  }

  return next();
});

router.afterEach(() => {
  document.body.classList.remove('navigation-loading');
});

router.onError(() => {
  navigationProgress?.cancel();
  document.body.classList.remove('navigation-loading');
});



export default router;
